import React, { useContext, useEffect, useState } from 'react'
import loaderGif from '../assets/images/loader.gif'
import AmbuNetLogo from '../assets/images/ambunetLogo.png'
import API, { setGlobalApiErrorHandler } from '../services/API'
import { ErrorBoundary } from 'react-error-boundary'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { UserContext } from '../App'
import { useNavigate } from 'react-router-dom'
import { Stack } from '@mui/material'
import BigModal from './Modals/BigModal'

const ErrorComponent = ({ hasError, errorMessage, ...props }) => {
  const [tenantNotFound, setTenantNotFound] = useState(false)
  const componentDidCatch = (error, errorInfo) => {
    setHasError(true)
  }
  const navigate = useNavigate()

  const ErrorFallBack = ({ error }) => (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={3}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background:
          'radial-gradient(circle at top left, rgba(35,154,164,0.22), transparent 35%), linear-gradient(135deg, #1A2230 0%, #242F40 45%, #101827 100%)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${AmbuNetLogo})`,
          backgroundRepeat: 'repeat',
          backgroundSize: '110px',
          opacity: 0.04,
        }}
      />

      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 520,
          borderRadius: 4,
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.18)',
          boxShadow: '0 24px 80px rgba(0,0,0,0.35)',
          background: 'rgba(255,255,255,0.96)',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            p: 3,
            background:
              'linear-gradient(135deg, #242F40 0%, #2c3e50 65%, #239AA4 150%)',
            color: 'white',
            textAlign: 'center',
          }}
        >
          <Box component="img" alt="Logo" src={loaderGif} width="130px" />

          <Typography variant="h5" fontWeight={900} color="white" mt={1}>
            {tenantNotFound
              ? 'This domain does not exist'
              : "Oops! There's been a glitch"}
          </Typography>

          <Typography variant="body2" sx={{ opacity: 0.85, mt: 1 }}>
            {tenantNotFound
              ? 'Please check the URL you are visiting.'
              : 'Something went wrong while loading AmbuNet.'}
          </Typography>
        </Box>

        <Box p={3}>
          <Stack spacing={2}>
            <Alert severity={tenantNotFound ? 'warning' : 'error'}>
              {tenantNotFound
                ? 'The organisation workspace could not be found.'
                : `Please go back and try again. If this keeps happening, please report a bug and include the steps that led to this page.`}

              {error?.message && (
                <Box component="strong" display="block" mt={1}>
                  {error.message}
                </Box>
              )}
            </Alert>

            {errorMessage && (
              <Alert severity="info">
                <AlertTitle>Error Message</AlertTitle>
                {errorMessage}
              </Alert>
            )}

            <Button
              fullWidth
              onClick={() => {
                if (tenantNotFound) {
                  window.location.href = 'https://ambunet.co.uk'
                } else {
                  window.location.replace('/')
                }
              }}
              variant="contained"
              sx={{
                borderRadius: 999,
                py: 1.2,
                textTransform: 'none',
                fontWeight: 800,
              }}
            >
              {tenantNotFound ? 'Go to AmbuNet website' : 'Return home'}
            </Button>

            <Button
              fullWidth
              onClick={() => navigate('/support')}
              color="error"
              sx={{
                borderRadius: 999,
                py: 1.2,
                textTransform: 'none',
                fontWeight: 800,
              }}
            >
              Report Bug
            </Button>

            <Typography
              variant="caption"
              color="text.secondary"
              textAlign="center"
            >
              AmbuNet®
            </Typography>
          </Stack>
        </Box>
      </Paper>
    </Box>
  )

  return (
    <ErrorBoundary
      // onError={logError}
      // onReset={handleResetError}
      // FallbackComponent={ErrorFallBack}
      fallback={<ErrorFallBack />}
    >
      {hasError ? <ErrorFallBack /> : props.children}
    </ErrorBoundary>
  )
}

export default ErrorComponent
